import React from "react";
import classes from "./styles/style.module.css";
import { DashboardMenuItems } from "./DashboardMenuItems";
import MenuItemElement from "./MenuItemElement";

const DashboardMenu = () => {
  let menuItems = DashboardMenuItems.map((item, index) => {
    return (
      <MenuItemElement title={item.title} menuItems={item.items} key={index} />
    );
  });
  return <div className={classes.menuContainer}>{menuItems}</div>;
};

export default DashboardMenu;
